function getTop() {
    return jQuery(window).scrollTop();
}

function pearlcohen_handle_search_service($list, $subtitle) {
    const search_keyword = this.val();
    const $recent_toughts = $list.closest('.recent-toughts');
    const $title = $recent_toughts.find('.recent-toughts__title');
    const $see_all_btn = $title.find('> a');
    $see_all_btn.hide();
    $list.html('<li class="-pre-recent-toughts__loader"></li>');
    $subtitle.hide();
    jQuery.ajax({
        type: 'GET',
        url: pearlcohen_get_ajax_url(),
        data: {
            search_keyword,
            'action': 'search_keyword'
        },
        dataType: 'json',
        success: function(items){
            let output = [];
            ( items.data ) && ( output = items.data.map( item => `<li>${item}</li>`) );
            if( items.success )
                $see_all_btn.attr('href', `${pearlcohen_get_home_url()}?s=${search_keyword}`).show();
            else
                $subtitle.show();

            $list.html( output.join('') );
        }
    });
}

;( function ($) {

    $.fn.doSlickSlide = function ( direction ) {
        var self = $(this),
            slickSection = self.closest('.slick-section');
        if( slickSection.length > 0 )
            slickSection.find('.slick-slider').slick(direction);
        return this;
    };

    $('.slick-next').on('click', function(){
        $(this).doSlickSlide('slickNext');
    });

    $('.slick-prev').on('click', function(){
        $(this).doSlickSlide('slickPrev');
    });

})(jQuery);


